import * as React from 'react';
import { Line } from '../../interfaces';
import renderGradients from '../../helpers/renderGradients';
import LineChartD3 from './LineChart.d3';
import styles from './LineChart.module.css';
import ChartWrapper from '../../components/ChartWrapper';
import TooltipService from '../../services/TooltipService';
import Tooltip from '../../components/Tooltip';
import { GraphGradient } from '@watcherr/charts';

interface LineChartProps {
  lines: Line[];
  loading: boolean;
  getTooltipContent?: (x: any) => any;
}

export const OldLineChart: React.FC<LineChartProps> = ({ lines, loading, getTooltipContent }) => {
  const chart = React.useRef<SVGSVGElement>(null);
  const d3Instance = React.useRef<LineChartD3>(null);
  const tooltip = React.useRef<TooltipService>(new TooltipService());
  React.useEffect(() => {
    if (chart.current) {
      d3Instance.current = new LineChartD3(chart.current, tooltip.current);
    }
  }, []);
  React.useEffect(() => {
    if (!loading) {
      d3Instance.current?.setLines(lines);
      d3Instance.current?.draw();
    }
  }, [lines, loading]);
  return (
    <ChartWrapper ratio={0.6} loading={loading}>
      <svg className={styles.LineChart} ref={chart}>
        {renderGradients(lines.map((line) => line.gradient).filter((x): x is GraphGradient => !!x))}
      </svg>
      {getTooltipContent && <Tooltip tooltip={tooltip.current} getTooltipContent={getTooltipContent} />}
    </ChartWrapper>
  );
};
